import {
  LEADS_LIST_SORT_OPTIONS,
  type LeadsListSortOption,
} from '@/core/components/leads/leads-list-sort';
import { ListSortSelect } from '@/core/components/layout';

export type LeadsListSortLabels = {
  sort: string;
  options: Record<LeadsListSortOption, string>;
};

type LeadsListSortSelectProps = {
  value: LeadsListSortOption;
  onChange: (next: LeadsListSortOption) => void;
  labels: LeadsListSortLabels;
};

export function LeadsListSortSelect({
  value,
  onChange,
  labels,
}: LeadsListSortSelectProps) {
  return (
    <ListSortSelect
      value={value}
      onChange={onChange}
      ariaLabel={labels.sort}
      triggerClassName="flex-1 sm:w-[12.5rem] sm:flex-none sm:shrink-0"
      options={LEADS_LIST_SORT_OPTIONS.map((option) => ({
        value: option,
        label: labels.options[option],
      }))}
    />
  );
}
